module.exports = __webpack_public_path__ + "img/KY.9e32abef.svg";